module.exports = __webpack_public_path__ + "static/media/linkedin-hover.3b20d947.svg";